import { useState, useCallback, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import componentStyles from "assets/theme/views/admin/react-bs-table";

import {
  Dialog,
  Tooltip,
  IconButton,
  LinearProgress,
  Grid,
} from "@material-ui/core";

import ImagePlaceholder from "components/Image/ImagePlaceholder";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField } from "utils/tables-utils";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

const useTabStyles = makeStyles({
  ...componentStyles,
});

const TABLE_PAGE_SIZE = 10;

const ProductImage = ({ row }) => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <ImagePlaceholder
      alt={`Imagem do produto ${row?.Codigo}`}
      src={row?.Foto}
      width={64}
      widthOnError={40}
      imagePreviewTitle={`Produto ${row?.Codigo}`}
    />
  </div>
);

const AddProductButton = ({ row, onAddProduct }) => (
  <Tooltip title="Adicionar à Vitrine">
    <IconButton
      disabled={row?.Disabled}
      aria-label="incluir"
      onClick={() => onAddProduct(row)}
    >
      <AddIcon />
    </IconButton>
  </Tooltip>
);

export default function TableProductsList({
  open,
  onClose,
  dataTable,
  search,
  currentPage,
  totalRegistros,
  setShowcaseItemsList,
  setProductsList,
  showcaseItemsList,
  searchingProducts,
}) {
  const classes = { ...useTabStyles() };
  const [loading, setLoading] = useState(false);
  const [newListItems, setNewListItems] = useState([]);

  const handleAddProduct = useCallback(
    (product) => {
      setShowcaseItemsList((prevState) => {
        if (prevState.some((item) => item.Codigo === product.Codigo)) {
          return prevState;
        }

        setProductsList((prevProducts) =>
          prevProducts?.map((item) => ({
            ...item,
            Disabled: item.Codigo === product.Codigo ? true : item.Disabled,
          }))
        );

        return [...prevState, { ...product, Disabled: true }];
      });
    },
    [setShowcaseItemsList, setProductsList]
  );

  const columnModel = [
    {
      dataField: "Foto",
      text: "Imagem",
      headerAlign: "center",
      align: "center",
      sort: false,
      formatter: (cell, row) => <ProductImage row={row} />,
      csvExport: false,
    },
    columnTextField(
      {
        dataField: "Nome",
        text: "Descrição Produto",
        align: "left",
        formatter: (cell) => <p style={{ whiteSpace: "normal" }}>{cell}</p>,
      },
      false
    ),
    {
      dataField: "incluir",
      text: "",
      isDummyField: true,
      headerStyle: { width: 45 },
      formatter: (cell, row) => (
        <AddProductButton row={row} onAddProduct={handleAddProduct} />
      ),
    },
  ];

  const rowStyle = (row) =>
    row.Disabled ? { border: "0.25rem solid #fbc6ca" } : undefined;

  const doSearch = useCallback(
    async (page) => {
      setLoading(true);
      try {
        await search({ page, showcaseList: newListItems });
      } finally {
        setLoading(false);
      }
    },
    [search, newListItems]
  );

  const handlePageChange = useCallback(
    (page) => {
      doSearch(page);
    },
    [doSearch]
  );

  useEffect(() => {
    setNewListItems(showcaseItemsList);
  }, [showcaseItemsList]);

  return (
    <Dialog
      maxWidth="md"
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      style={{ padding: "rem", overflowX: "auto" }}
    >
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Grid>
      {searchingProducts ? (
        <div style={{ padding: "2rem" }}>
          <span>Buscando produtos...</span>
          <LinearProgress />
        </div>
      ) : (
        <ToolkitTable
          searched={Boolean(dataTable)}
          keyField="Codigo"
          styledRow={rowStyle}
          dataTable={dataTable}
          columnModel={columnModel}
          headerTitle="Produtos"
          pagination={{
            options: [TABLE_PAGE_SIZE.toString()],
            defaultOption: TABLE_PAGE_SIZE,
            totalSize: totalRegistros,
            showTotal: false,
            page: currentPage,
            onPageChange: handlePageChange,
            sizePerPage: TABLE_PAGE_SIZE,
          }}
          loading={loading}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          bootstrapTableProps={{
            remote: true,
            onTableChange: () => {},
          }}
        />
      )}
    </Dialog>
  );
}
